import Tool, { type IToolActionInput, type IToolEnabledInput } from './Tool';
import { isSimpleSelection } from '../objects/guards';
import { type WhiteboardRecordTypeNames } from '../shared-types';
import { getApplicableSelectedObjects } from './ToolCreateRecords';

class ToolLinkRecord extends Tool {
  static toolName = 'Link to Aha! record';

  static async action({ controller, selection }: IToolActionInput) {
    const records = await controller.props.selectAhaRecords?.({
      multipleRecords: false,
    });

    if (!records || records.length === 0) {
      controller.actionShowMessage({
        type: 'error',
        message: 'Could not find valid record to link',
      });
      return;
    }

    const record = records[0];
    let recordType = record.typename as WhiteboardRecordTypeNames;
    let recordId = record.id;

    // Fallback to parsing the path if the typename or record id is not available
    // This can have some issues when path/internal names do not match the (external)
    // names we use in GraphQL
    if (!recordType || !recordId) {
      const matches = records?.[0].path?.match(/\/([^/]+)\/([^/]+)/);
      if (matches?.length === 3) {
        [recordType, recordId] = matches.slice(1) as [
          WhiteboardRecordTypeNames,
          `${number}`
        ];
      }
    }

    if (!recordType || !recordId) {
      controller.actionShowMessage({
        type: 'error',
        message: `Selected record is not linkable in whiteboard ${recordType}`,
      });
      return;
    }

    selection.set({ recordType, recordId });
  }

  static available({ selection, controller }: IToolEnabledInput): boolean {
    const applicableSelection =
      selection && getApplicableSelectedObjects(selection);
    const obj = applicableSelection?.[0];
    return !!(
      controller.recordManager &&
      selection &&
      obj &&
      obj.type !== 'comment' &&
      obj.recordId == null &&
      !isSimpleSelection(selection)
    );
  }
}

export default ToolLinkRecord;
